import React, { Component, useEffect, useState } from 'react';

function Search(props) {
    
    const [value,setValue] = useState('')
    
    function handleChange(event) {
      setValue(event.target.value);
      
      
      props.setSearch(event.target.value.toLowerCase().replaceAll('_', ' '));
      if (event.target.value != '') {
        document.getElementById('network_search_cancel').style.display = 'block';  
      }
      else {
        document.getElementById('network_search_cancel').style.display = 'none';
      }
    }

    function handleSubmit(event) {
      event.preventDefault();
      props.setSearch('');
      setValue('');  
      document.getElementById('network_search_cancel').style.display = 'none';
    }
      return (
        <form onSubmit={handleSubmit}>
          <label>
            <input value={value} type="text" id = "widget_input" onChange={(e)=>handleChange(e)} placeholder="Related endpoints..."/>
          </label>
          <input id = "network_search_cancel" type="submit" value="×" />
        </form>
      );
    
  }

  export default Search